import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyExperiments } from 'constants/optimizely'
import { accountAccessShowLogin, modalClose } from 'actions/UiActions'
import { hasPassedWalledGarden } from 'selectors/accountSelectors'
import { EUROPE_REGIONS } from 'constants/config/region'

function useEuropeOfferPageWalledGarden() {
  const dispatch = useAppDispatch()
  const isWalledGardenEuropeOffersEnabled = useOptimizelyExperiment(OptimizelyExperiments.walledGardenEuropeOffers)

  const countryCode = useAppSelector(state => state.geo.currentRegionCode)
  const hasPassesWalledGarden = useAppSelector(hasPassedWalledGarden)

  useEffect(() => {
    const isEurope = EUROPE_REGIONS.has(countryCode)

    if (!isWalledGardenEuropeOffersEnabled || hasPassesWalledGarden || !isEurope) return

    dispatch(accountAccessShowLogin('login', false))

    return () => {
      dispatch(modalClose())
    }
  }, [countryCode, dispatch, hasPassesWalledGarden, isWalledGardenEuropeOffersEnabled])
}

export default useEuropeOfferPageWalledGarden
